import React, { useState } from 'react';
import select from '#lib/components/select.jsx';
import Dialog from '#lib/components/dialog.jsx';
import Button from '#lib/components/button.jsx';
import { addClasses } from '#lib/helpers/class.js';
import { capitalize } from '#lib/utils/string.js';

export default function LanguageModal(props) {
    const { isShown, onClose, onClick, language } = props;
    const options = INTL_LANGS.split(',');
    const languages = options.reduce((acc, curr) => {
        const languageNames = new Intl.DisplayNames([language ?? 'en'], { type: 'language' });
        acc[curr] = capitalize(languageNames.of(curr));
        return acc;
    }, {});

    const [languageId, setLanguageId] = useState('en');
    const _onClick = () => {
        onClick(languageId);
        onClose();
    };

    const onChange = (v) => {
        let newLang = Object.keys(languages);
        newLang = newLang.find((el) => languages[el] === v);
        setLanguageId(newLang);
    };

    return (
        <Dialog isOpen={isShown} onClose={onClose} className="h-screen flex items-center justify-center fixed inset-4">
            <Dialog.Panel className="w-full max-w-[400px] mx-10 flex flex-col gap-3 z-50">
                <div className="pr-8">
                    <p> {_t.orders.languageSelection()} </p>
                    <Dialog.CloseButton />
                </div>
                <div className="flex gap-2 items-center z-50">
                    <select.Full
                        options={Object.values(languages)}
                        onChange={onChange}
                        defaultValue={languages[languageId]}
                        name="Language"
                        placeholder={_t.connections.selectLanguage()}
                        inPortal={false}
                    />
                    <Button className={addClasses('w-1/2 h-full')} as="button" look="primary" onClick={_onClick}>
                        {_t.orders.import()}
                    </Button>
                </div>
            </Dialog.Panel>
        </Dialog>
    );
}
